import { useCallback, useState } from 'react';

import { sortRows } from '../utils/tableSort';

export function useTableSort() {
  const [tableSort, setTableSort] = useState({});

  const requestSort = useCallback((tableId, key) => {
    if (!tableId || !key) return;
    setTableSort((prev) => {
      const cur = prev[tableId];
      const nextDir = cur && cur.key === key && cur.direction === 'asc' ? 'desc' : 'asc';
      return { ...prev, [tableId]: { key, direction: nextDir } };
    });
  }, []);

  const sortData = useCallback(
    (data, tableId) => sortRows(data, tableSort[tableId]),
    [tableSort]
  );

  return { tableSort, requestSort, sortData };
}
